import React from "react";
import { Bar } from "react-chartjs-2";
import { monthNames } from "../../../../util/helpers";

const ClinicsGraph = ({ months, data }) => {
  const labels = monthNames.splice(0, months);
  return (
    <Bar
      data={{
        labels,
        datasets: [
          {
            label: "Clinics",
            data: data,
            backgroundColor: "#1AA8E9",
          },
        ],
      }}
      options={{
        responsive: true,
        plugins: { legend: { display: false } },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            beginAtZero: true,

            type: "linear",

            grid: {
              display: true,
            },
            ticks: {
              min: 0,
              stepSize: 1,
            },
          },
        },
      }}
    />
  );
};

export default ClinicsGraph;
